export const AppName = "Vivian table tennis academy";

export const DEFAULT_EMAIL = ""; // "a21071@hotmail.com";
export const DEFAULT_PASSWORD = ""; //"Ab12@34578";
